import { render, staticRenderFns } from "./ControlWrapping.vue?vue&type=template&id=623b0d06&scoped=true"
import script from "./ControlWrapping.vue?vue&type=script&lang=js"
export * from "./ControlWrapping.vue?vue&type=script&lang=js"
import style0 from "./ControlWrapping.vue?vue&type=style&index=0&id=623b0d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623b0d06",
  null
  
)

export default component.exports